import { PLAYTECH_CLOSE_FRAME_CLASS_ID } from '@/features/game-window-integration/providers/playtech/constants';
import {
  PLAYTECH_LIVE_GAME_STUDIOS,
  PlaytechCloseFrameMessage,
} from '@/features/game-window-integration/providers/playtech/types';

export const isPlaytechLiveGameStudio = (gameStudio?: string): boolean =>
  !!gameStudio && PLAYTECH_LIVE_GAME_STUDIOS.includes(gameStudio.toUpperCase());

/** APICloseMeRequest — Playtech poker signals the host should close the game frame. */
export const isPlaytechCloseFrameMessage = (
  data: unknown,
): data is PlaytechCloseFrameMessage => {
  if (typeof data !== 'object' || data === null || !('classId' in data)) {
    return false;
  }

  const classId = Number((data as PlaytechCloseFrameMessage).classId);

  return Number.isInteger(classId) && classId === PLAYTECH_CLOSE_FRAME_CLASS_ID;
};

export const parsePlaytechMessageData = (data: unknown): unknown => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  if (typeof data === 'object' && data !== null) {
    return data;
  }

  return null;
};
